"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = {
  AD_ROLL: 'AdRoll',
  AD_ID: 'adId',
  ALL_DOMAINS_KEY: _UrlPathParams.ALL_DOMAINS,

  /* Extra unique identifier field */
  ALL_DOMAINS_OR_DOMAIN_NAME: 'allDomainsOrDomainName',
  ATTACHED_STYLESHEETS: 'attachedStylesheets',
  BACKGROUND_COLOR: 'backgroundColor',
  BODY_BORDER_COLOR: 'bodyBorderColor',
  BODY_BORDER_COLOR_CHOICE: 'bodyBorderColorChoice',
  BODY_COLOR: 'bodyColor',
  BODY_END_HTML: 'bodyEndHtml',
  BODY_OVERRIDE_BY_DOMAIN: 'bodyOverrideByDomain',
  CANONICAL_URL_PAGES: 'selfLinkRelCanonicalizePagesAndBlogPosts',
  CANONICAL_URL_BLOG_LISTING: 'selfLinkRelCanonicalizeBlogListingPages',
  COLOR_PICKER_FAVORITE_1: 'colorPickerFavorite1',
  COLOR_PICKER_FAVORITE_2: 'colorPickerFavorite2',
  COLOR_PICKER_FAVORITE_3: 'colorPickerFavorite3',
  COLOR_PICKER_FAVORITE_4: 'colorPickerFavorite4',
  COLOR_PICKER_FAVORITE_5: 'colorPickerFavorite5',
  COLOR_PICKER_FAVORITE_6: 'colorPickerFavorite6',
  COMPANY_DOMAIN: 'companyDomain',
  COMPANY_NAME: 'companyName',
  CONTENT_SEARCH_RESULTS_PAGE_PATH: 'contentSearchResultsPagePath',
  CONTENT_SEARCH_RESULTS_TEMPLATE_PATH: 'contentSearchResultsTemplatePath',
  COS_EXTENSION_RESOURCE: 'cos_extension_resource',
  CUSTOM_404: 'custom404',
  CUSTOM_500: 'custom500',
  CUSTOM_PASSWORD_TEMPLATE_PATH: 'customPasswordTemplatePath',
  CUSTOM_SUBSCRIPTION_CONFIRMATION: 'customSubscriptionConfirmation',
  CUSTOM_SUBSCRIPTION_PREFERENCES: 'customSubscriptionPreferences',
  CUSTOM_UNSUBSCRIBE_SIMPLE: 'customUnsubscribeSimple',
  DRIFT: 'Drift',
  EMAIL_BODY_PADDING: 'emailBodyPadding',
  EMAIL_BODY_WIDTH: 'emailBodyWidth',
  EMAIL_OPTIN_CONFIRMATION_PAGE_ID: 'emailOptinConfirmationPageId',
  EMAIL_RESUBSCRIBE_ENABLED: 'emailResubscribeEnabled',
  EMAIL_RSS_DATE_FORMAT: 'emailRssDateFormat',
  EMAIL_RSS_DATE_LANGUAGE: 'emailRssDateLanguage',
  ENABLE_LANGUAGE_SPECIFIC_REDIRECTS: 'enableLanguageSpecificRedirects',
  ENABLED: 'enabled',
  FAVICON_SRC: 'faviconSrc',
  GOOGLE_ANALYTICS: 'GoogleAnalytics',
  GRAYMAIL_SUPPRESSION_ENABLED_BY_DEFAULT: 'graymailSuppressionEnabledByDefault',
  INCLUDE_JQUERY: 'includeJquery',
  INCLUDE_JQUERY_MIGRATE: 'includeJQueryMigrate',
  INCLUDE_JQUERY_IN_FOOTER: 'includeJqueryInFooter',
  JQUERY_VERSION: 'jqueryVersion',
  LOGO_ALT: 'logoAlt',
  LOGO_HEIGHT: 'logoHeight',
  LOGO_SRC: 'logoSrc',
  LOGO_WIDTH: 'logoWidth',
  FILE_HOSTING_DOMAIN: 'defaultFileHostingDomain',
  FOOTER_HTML: 'footerHtml',
  HEAD_HTML: 'headHtml',
  INCLUDE_PRIMARY_CSS: 'includeDefaultCustomCss',
  JS_INTEGRATIONS: 'jsIntegrations',
  MERGE_TAG_DEFAULTS: 'mergeTagDefaults',
  OWNER_MERGE_TAG_DEFAULTS: 'ownerMergeTagDefaults',
  PAGE_OWNER_MERGE_TAG_DEFAULTS: 'pageOwnerMergeTagDefaults',
  PAGE_MERGE_TAG_DEFAULTS: 'pageMergeTagDefaults',
  PAGE_ACCOUNT_MERGE_TAG_DEFAULTS: 'pageAccountMergeTagDefaults',
  ACCOUNT_MERGE_TAG_DEFAULTS: 'accountMergeTagDefaults',
  PARTITIONING_ACTIVATED_FOR_BLOG_POSTS: 'partitioningActivatedForBlogPosts',
  PARTITIONING_ACTIVATED_FOR_LANDING_PAGES: 'partitioningActivatedForLandingPages',
  PARTITIONING_ACTIVATED_FOR_DOMAIN_PUBLISHING: 'partitioningActivatedForDomainPublishing',
  PIXEL_ID: 'pixelId',
  PRIMARY_ACCENT_COLOR: 'primaryAccentColor',
  PRIMARY_FONT: 'primaryFont',
  PRIMARY_FONT_COLOR: 'primaryFontColor',
  PRIMARY_FONT_SIZE: 'primaryFontSize',
  ROBOTS_TXT: 'robotsTxt',
  SECONDARY_ACCENT_COLOR: 'secondaryAccentColor',
  SECONDARY_FONT: 'secondaryFont',
  SECONDARY_FONT_COLOR: 'secondaryFontColor',
  SECONDARY_FONT_SIZE: 'secondaryFontSize',
  SELECTED_DOMAIN: 'selectedDomain',
  SITE_SETTINGS: 'SiteSettings',
  ID: 'id',
  TRACKING_ID: 'trackingId',
  TYPE: 'type',
  UTM_AUTOMATIC_PLAIN_TEXT_TRACKING: 'utmAutomaticPlainTextTracking',
  UTM_AUTOMATIC_TRACKING: 'utmAutomaticTracking',
  UTM_IDENTITY_TRACKING: 'utmIdentityTracking',
  UTM_SOURCE_TRACKING: 'utmSourceTracking',
  HSTS_DURATION: 'hstsMaxAge',
  HSTS_PRELOAD: 'isHstsPreloadEnabled',
  HSTS_INCLUDE_SUBDOMAINS: 'isHstsIncludeSubdomainsEnabled',
  MEMBERSHIP_COMPANY_NAME: 'membershipCompanyName',
  MEMBERSHIP_WEBSITE_ADMIN: 'membershipWebsiteAdmin',
  MEMBERSHIP_REGISTRATION_REDIRECT: 'membershipRegistrationRedirectId',
  MEMBERSHIP_LOGIN_REDIRECT: 'membershipLoginRedirectId',
  MEMBERSHIP_LOGOUT_REDIRECT: 'membershipLogoutRedirectId',
  MEMBERSHIP_REGISTRATION_TEMPLATE_ID: 'membershipRegistrationTemplateId',
  MEMBERSHIP_LOGIN_TEMPLATE_ID: 'membershipLoginTemplateId',
  MEMBERSHIP_PASSWORD_RESET_REQUEST_TEMPLATE_ID: 'membershipPasswordResetRequestTemplateId',
  MEMBERSHIP_PASSWORD_RESET_TEMPLATE_ID: 'membershipPasswordResetTemplateId',
  MEMBERSHIP_ACCESS_DENIED_TEMPLATE_ID: 'membershipAccessDeniedTemplateId',
  MEMBERSHIP_LOGOUT_TEMPLATE_ID: 'membershipLogoutTemplateId',
  MEMBERSHIP_REGISTRATION_EMAIL_TEMPLATE_ID: 'membershipRegistrationEmailTemplateId',
  MEMBERSHIP_PASSWORD_RESET_EMAIL_TEMPLATE_ID: 'membershipPasswordResetEmailTemplateId',
  MEMBERSHIP_PASSWORD_SAVED_EMAIL_TEMPLATE_ID: 'membershipPasswordSavedEmailTemplateId'
};
exports.default = _default;
module.exports = exports.default;